import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../App';
import { TOPUP_PACKAGES } from '../data/constants';

const PAYMENT_METHODS = [
  { id: 'card',     label: 'Debit / Credit Card', icon: '💳' },
  { id: 'paypal',   label: 'PayPal',              icon: '🅿️'  },
  { id: 'mpesa',    label: 'M-Pesa Global',       icon: '📱' },
  { id: 'bank',     label: 'Bank Transfer',       icon: '🏦' },
];

export default function TopUp() {
  const navigate                = useNavigate();
  const { credits, addCredits, plan } = useApp();

  const [selectedPkg,    setSelectedPkg]    = useState(TOPUP_PACKAGES[1].id);
  const [paymentMethod,  setPaymentMethod]  = useState('card');
  const [confirmed,      setConfirmed]      = useState(false);
  const [processing,     setProcessing]     = useState(false);

  const pkg = TOPUP_PACKAGES.find(p => p.id === selectedPkg);

  function handleConfirm() {
    setProcessing(true);
    setTimeout(() => {
      addCredits(pkg.credits);
      setConfirmed(true);
      setProcessing(false);
    }, 1200);
  }

  if (confirmed) {
    return (
      <div className="topup-page">
        <header className="topup-header">
          <div className="topup-header-logo">mudiaspora.</div>
        </header>
        <div className="topup-body" style={{ textAlign: 'center', paddingTop: 80 }}>
          <div style={{ fontSize: 64, marginBottom: 20 }}>🎉</div>
          <h2 style={{ fontSize: 28, fontWeight: 800, marginBottom: 8 }}>Credits added!</h2>
          <p className="text-muted" style={{ marginBottom: 32 }}>
            {pkg.credits} credits have been added to your account.
          </p>
          <div className="card" style={{ display: 'inline-block', padding: '20px 40px', marginBottom: 32 }}>
            <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 4 }}>New balance</div>
            <div style={{ fontSize: 48, fontWeight: 900, color: 'var(--amber)' }}>
              {Math.round((credits) * 10) / 10}
            </div>
            <div style={{ fontSize: 14, color: 'var(--text-muted)' }}>credits</div>
          </div>
          <br />
          <button className="btn btn-primary btn-lg" onClick={() => navigate('/dashboard')}>
            Back to Dashboard →
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="topup-page">
      <header className="topup-header">
        <button className="btn btn-ghost btn-sm" onClick={() => navigate('/dashboard')}>
          ← Dashboard
        </button>
        <div className="topup-header-logo">mudiaspora.</div>
      </header>

      <div className="topup-body">
        {/* Balance card */}
        <div className="topup-balance-card">
          <div>
            <div className="topup-balance-label">Current credit balance</div>
            <div className="topup-balance-num">{credits}</div>
            <div className="topup-balance-unit">credits</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            {plan && (
              <>
                <div style={{ fontSize: 14, opacity: 0.8, marginBottom: 4 }}>Your plan</div>
                <div style={{ fontSize: 20, fontWeight: 800 }}>{plan.name}</div>
                <div style={{ fontSize: 13, opacity: 0.7 }}>{plan.credits} cr / month included</div>
              </>
            )}
            <div style={{ marginTop: 8, fontSize: 13, opacity: 0.7 }}>
              Extra credits at ${plan?.extraCreditPrice ?? 3} each
            </div>
          </div>
        </div>

        {/* Packages */}
        <h2 className="topup-section-title">Choose a top-up package</h2>
        <div className="topup-packages-grid">
          {TOPUP_PACKAGES.map(p => (
            <div
              key={p.id}
              className={`topup-pkg-card ${selectedPkg === p.id ? 'selected' : ''}`}
              onClick={() => setSelectedPkg(p.id)}
            >
              {p.popular && <div className="topup-pkg-popular">Most Popular</div>}
              <div className="topup-pkg-credits">{p.credits}</div>
              <div className="topup-pkg-credits-label">credits</div>
              <div className="topup-pkg-price">${p.price}</div>
              <div className="topup-pkg-per-credit">${p.pricePerCredit.toFixed(2)} per credit</div>
            </div>
          ))}
        </div>

        {/* Payment method */}
        <h2 className="topup-section-title">Payment method</h2>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4,1fr)',
            gap: 12,
            marginBottom: 28,
          }}
        >
          {PAYMENT_METHODS.map(m => (
            <button
              key={m.id}
              className={`property-type-btn ${paymentMethod === m.id ? 'active' : ''}`}
              onClick={() => setPaymentMethod(m.id)}
              style={{ padding: '14px 8px' }}
            >
              <span className="property-type-icon">{m.icon}</span>
              {m.label}
            </button>
          ))}
        </div>

        {/* Confirm box */}
        {pkg && (
          <div className="topup-confirm-box">
            <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 16 }}>Order summary</h3>
            <div className="topup-confirm-row">
              <span className="topup-confirm-label">Package</span>
              <span className="topup-confirm-value">{pkg.credits} credits</span>
            </div>
            <div className="topup-confirm-row">
              <span className="topup-confirm-label">Price</span>
              <span className="topup-confirm-value">${pkg.price}</span>
            </div>
            <div className="topup-confirm-row">
              <span className="topup-confirm-label">Payment via</span>
              <span className="topup-confirm-value">
                {PAYMENT_METHODS.find(m => m.id === paymentMethod)?.label}
              </span>
            </div>
            <div className="topup-confirm-row">
              <span className="topup-confirm-label">Current balance</span>
              <span className="topup-confirm-value amber">{credits} cr</span>
            </div>
            <div className="topup-confirm-row">
              <span className="topup-confirm-label">New balance</span>
              <span className="topup-confirm-value green">
                {Math.round((credits + pkg.credits) * 10) / 10} cr
              </span>
            </div>
          </div>
        )}

        <div className="alert alert-amber" style={{ marginBottom: 16 }}>
          🔒 This is a demo — no real payment is processed.
        </div>

        <button
          className="btn btn-amber btn-lg btn-full"
          onClick={handleConfirm}
          disabled={processing}
        >
          {processing ? 'Processing…' : `Add ${pkg?.credits} Credits — $${pkg?.price}`}
        </button>
      </div>
    </div>
  );
}
